export default "__VITE_ASSET__DRUVVrBY__"